export default {
  CARD: {
    TITLE: `Offres de quart de travail`
  },
  PRIORITY_DELAY: `Délai de priorité restant : {{ until }}`,
  REFUSE_ALL_SHIFT_OFFERS: `Tout refuser`,
  ALL_SHIFT_OFFERS_REFUSED: `Toutes les offres ont été refusées`,
  NO_OFFERS: `Vous n'avez aucune offre en ce moment.`,
  SHIFT_ACCEPTED: `Accepté`,
  SHIFT_REFUSED: `Refusé`,
  SHIFT_NOT_AVAILABLE_DESCRIPTION: `Ce quart de travail n'est plus disponible.`,
  ARRIVALTIME: {
    LABEL: `Vers quelle heure pensez-vous pouvoir arriver?`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  ARRIVAL_TIME_REQUIRED: `Vous ne pouvez pas soumettre une heure d'arrivée vide`,
  ALREADY_ACCEPTED_SHIFT: `Vous n'êtes plus éligible à ce quart`
}
